module.exports = __webpack_public_path__ + "operace-nosu_2_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-nosu_2_after_tn.jpg
// module id = 1599
// module chunks = 0